<template>
  <div class="district">
    <div class="district-head">
      <button class="back" @click="goBack">返回</button>
      <input
        type="text"
        placeholder="请输入要搜索的关键词"
        @blur="getStopDelivery"
        v-model="keyword"
      />
    </div>
    <div class="district-body">
      <div class="body-title">
        <div class="title">省份</div>
        <div class="title">城市</div>
        <div class="title ">地区</div>
        <div class="title region">网点</div>
        <div class="title">停发原因</div>
        <div class="title">停发日期</div>
      </div>
      <div class="load" v-if="isLoading">
        <div class="round"></div>
        加载中
      </div>
      <div class="list" v-if="areas.children.length != 0">
        <div class="item" v-for="(item, index) in areas.children" :key="index">
          <div class="title">
            {{ (item.value && item.value.province.value) || item.province }}
          </div>
          <div class="title">
            {{ (item.value && item.value.city.value) || item.city }}
          </div>
          <div class="title ">
            {{ (item.value && item.value.region.value) || item.region }}
          </div>
          <div class="title region">
            {{ (item.value && item.value.node.value) || item.node }}
          </div>
          <div class="title">
            {{ (item.value && item.value.reason.value) || item.reason }}
          </div>
          <div class="title">
            {{ (item.value && item.value.date.value) || item.date }}
          </div>
        </div>
      </div>
      <div class="none" v-if="areas.children == 0 && !isLoading && !isError">
        暂无数据
      </div>
    </div>
  </div>
</template>
<script>
import { stopDeliveryArea } from "@api/user";
export default {
  data() {
    return {
      keyword: "",
      areas: {
        id: "0",
        children: []
      },
      isLoading: true,
      isError: false
    };
  },
  mounted() {
    this.getStopDelivery();
  },
  methods: {
    getStopDelivery() {
      this.isLoading = true;
      this.areas.children = [];
      // let keyword = encodeURIComponent(this.keyword);
      stopDeliveryArea(this.keyword)
        .then(res => {
          console.log(res);
          this.areas.children = res.data;
          this.isLoading = false;
        })
        .catch(err => {
          console.log("逮捕");
          this.isLoading = false;
          // let error = JSON.parse(err);
          console.log(err);
          this.isError = true;
        });
    },
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>
<style lang="scss" scoped>
.district {
  background-color: #fff;
  min-height: 100%;
  &-head {
    display: flex;
    align-items: center;
    padding: 10px 6px;
    border-bottom: solid 1px rgb(245, 245, 245);
    input {
      flex-grow: 1;
      border-radius: 5px;
      border: solid 2px #000;
      padding: 4px 6px;
      box-sizing: border-box;
      margin-left: 10px;
    }
    button {
      background-color: rgb(151, 192, 170);
      color: #fff;
      padding: 4px 8px;
      font-size: 16px;
      border-radius: 4px;
    }
  }
  &-body {
    text-align: center;
    .body-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .list {
      .item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-bottom: 10px;
        margin-bottom: 10px;
        border-bottom: solid 1px rgb(245, 245, 245);
      }
    }
    .title {
      width: 15%;
    }
    .region {
      width: 30%;
    }
  }
  .load {
    margin-top: 200px;
    .round {
      width: 40px;
      height: 40px;
      border: dashed 2px #000;
      border-radius: 50%;
      animation: myload 2s infinite;
      margin: 0 auto;
    }
    @keyframes myload {
      from {
        transform: rotate(0);
      }
      to {
        transform: rotate(360deg);
      }
    }
  }
}
</style>
